import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { PermissionsService } from '../../services/permissions.service';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.css']
})
export class ConfigurationComponent implements OnInit, OnDestroy {

  private _destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private _permissionsService: PermissionsService,
  ) { }

  ngOnInit(): void {
    // Wait for studio permissions to load before redirecting,
    // so canAccess() has accurate data.
    this._permissionsService.studioPermissionsLoaded.pipe(
      filter(loaded => loaded === true),
      take(1),
      takeUntil(this._destroy$),
    ).subscribe(() => {
      if (this._permissionsService.canAccess('config_studio')) {
        this.router.navigate(['/configuration/studio-information']);
      } else if (this._permissionsService.canAccess('staff_view')) {
        this.router.navigate(['/configuration/staff-management']);
      } else {
        this.router.navigate(['/configuration/faq']);
      }
    });
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

}
